import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, TextField } from '@mui/material'
import { regexConstants } from '../../constants/regEx';

const AddDerateModal = ({ onToggleModal, derateData, modeType, onDerateFieldChange,onDerateFocusChange, onAddDerateColumn,ratioDerateData, handleItemClicked }) => {
    return (
        <Dialog open={true} aria-labelledby="customized-dialog-title"
            className='add-lease-dialog'
            maxWidth="sm">
            <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>Add DeRate</DialogTitle>
            <DialogContent dividers style={{ width: 300 }} >
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <TextField
                            required
                            id="derate"
                            value={derateData?.derate}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (regexConstants.derateRegex.test(value)) { onDerateFieldChange("derate", value); }
                              }}
                            label={`Derate${ratioDerateData?.interval?.label ? `/${ratioDerateData?.interval?.label}` : ""}`}
                            variant="outlined"
                            size="small"
                            margin="normal"
                            error={derateData?.error ?derateData?.error : null }
                            helperText={
                                derateData?.error
                                  ? derateData.error
                                  :"Enter comma-separated values (e.g. 10,10.25). Each value must be ≤ 100."
                              }
                            slotProps={{
                                inputLabel: { shrink: true },
                                input: {endAdornment: (<InputAdornment position="end">%</InputAdornment>) }
                            }}
                            onFocus={onDerateFocusChange}
                            fullWidth
                            disabled={modeType === 'view'}
                        />
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions dividers>
                <Button className='cancel-btn' variant="outlined" size='small' color="primary" onClick={() => { onToggleModal(); handleItemClicked?.('Close Button') }} > Close </Button>
                <Button variant="contained" size='small' color="primary" onClick={() => { onAddDerateColumn(); handleItemClicked?.('Add Button') }} > Add </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddDerateModal